import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7d1aa2d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/consumables.css?vue&type=style&index=0&id=7d1aa2d8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1aa2d8",
  null
  
)

export default component.exports